import { Component, OnInit, AfterContentChecked, Input } from '@angular/core';
import { SpinnerService } from 'src/app/components/shared-components/spinner/spinner.service';

@Component({
  selector: 'app-account-tickets-card',
  templateUrl: './account-tickets-card.component.html',
  styleUrls: ['./account-tickets-card.component.scss']
})
export class AccountTicketsCardComponent implements OnInit, AfterContentChecked {

  @Input() data;
  enableCount: any;
  disableCount: any;
  showCounter: boolean;

  constructor(private spinnerService: SpinnerService) { }

  ngOnInit() { }

  ngAfterContentChecked() {
    this.spinnerService.show('ticket-counts-spinner');
    if ((null !== this.data) && (undefined !== this.data) && ('-' !== this.data)) {
      this.spinnerService.hide('ticket-counts-spinner');
      this.showCounter = true;
      this.enableCount = this.data.availableTickets;
      this.disableCount = this.data.unavailableTickets;
    } else if ('-' === this.data) {
      this.enableCount = '-';
      this.disableCount = '-';
      this.showCounter = true;
      this.spinnerService.hide('ticket-counts-spinner');
    }
  }
}
